export const getPercent = (parts: number, whole: number, fixedPoint = 2) =>
  parseFloat((100 * (parts / whole)).toFixed(fixedPoint))
